import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('SpecialProcurementType?page=' + page, {params});
    }, 
    getByPlant(plant) {
        return Service().get('SpecialProcurementType/get-by-plant/' + plant);
    },
    show(id) {
        return Service().get('SpecialProcurementType/show/'+id);
    },    
    create(params) {
        return Service().post('SpecialProcurementType/create', params);
    },
    update(id, params) {
        return Service().post('SpecialProcurementType/update/'+id, params);
    },
    delete(id) {
        return Service().post('SpecialProcurementType/delete/'+id);
    }
}